// Angular-Module
import {Injectable} from '@angular/core';
// ReactiveX for JavaScript
import {Observable} from 'rxjs';
// Globale Services
import {BackendService} from '@global/services/backend.service';

@Injectable({providedIn: 'root'})
export class InstitutionsPublicNoteService {
    // Konstruktor (inkl. dependency injection)
    constructor(private backendService: BackendService) {}

    /**
     * @brief   Die public-node der Einrichtung laden
     * @param id
     * @param gridPage
     * @param   number  id      Einrichtung-ID
     * @returns  Observable<any>
     */
    loadPublicNoteDetails(id: number): Observable<any> {
        return this.backendService.getRequest('crud/institutions/' + id);
    }

    /**
     * @param id
     * @param formData
     * @brief   Speichert Notizen einer Einrichtung
     * @returns  Observable<any>
     */
    saveData(id: number, formData: any): Observable<any> { 
        return this.backendService.postRequest('crud/institutions/update/' + id, formData);
    }

}
